var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDdnLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.94 0c-2.63 0-5.21.74-7.44 2.13 3.43.52 6.92 1.15 10.3 1.67.78.15 1.04.31 1.04.68 0 2.86.05 5.77 0 8.63-.16 3.49.15 7.08 0 10.57 0 .52-.63.83-1.51.93-3.17.52-6.4.99-9.57 1.46a14.66 14.66 0 0 0 7.12 1.98A14.05 14.05 0 0 0 32.93 14a13.9 13.9 0 0 0-14-14Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.19 22.22c.05-2.97-.06-5.99 0-8.95.05-2.45 0-4.94 0-7.39a.6.6 0 0 0-.53-.62c-2.6-.63-5.1-1.3-7.64-1.88-.78-.2-1.61-.36-2.34-.52H9.2v-.05a3.45 3.45 0 0 1-.78-.16V25.3c.32.04.63.1.93.2.16.01.32 0 .47-.05 1.15-.3 2.19-.62 3.33-.83 2.03-.52 4.16-.99 6.25-1.5.46-.16.78-.42.78-.9Zm-1.46-7.65a1.02 1.02 0 0 1-1.15-.94 1.1 1.1 0 0 1 1.15-.93 1.02 1.02 0 0 1 1.14.93.72.72 0 0 1-.47.68v.15a.31.31 0 0 1-.2-.05c-.14.1-.3.16-.47.16Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.87 32c10.98 0 19.88-.8 19.88-1.77 0-.98-8.9-1.77-19.88-1.77C8.9 28.46 0 29.26 0 30.23 0 31.21 8.9 32 19.87 32Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.61 7.61h6.27c4.78 0 8.04 3.02 8.04 7.44s-3.26 7.44-8.04 7.44h-6.27V7.61Zm6.15 13.03c3.67 0 6.03-2.25 6.03-5.59s-2.36-5.59-6.03-5.59h-4.02v11.18h4.02ZM60.17 7.61h2.12v14.88h-2.12V7.61ZM79.55 7.61v14.88h-1.74l-8.93-11.1v11.1h-2.12V7.61h1.74l8.92 11.1V7.6h2.13ZM94.32 14.97h2.04v5.8a8.8 8.8 0 0 1-5.63 1.89c-4.57 0-7.93-3.21-7.93-7.61s3.36-7.61 7.97-7.61c2.36 0 4.36.79 5.72 2.3l-1.32 1.31a5.9 5.9 0 0 0-4.31-1.72c-3.44 0-5.93 2.4-5.93 5.72 0 3.27 2.49 5.72 5.9 5.72a6.3 6.3 0 0 0 3.5-.96v-4.84ZM100.78 7.61h5.89c4.72 0 7.9 3.1 7.9 7.44s-3.18 7.44-7.9 7.44h-5.89V7.61Zm5.8 13.9c4.21 0 6.91-2.68 6.91-6.46s-2.7-6.46-6.9-6.46h-4.72V21.5h4.71ZM136.1 7.61v14.88h-.9L125.06 9.57v12.92h-1.08V7.61h.91l10.12 12.92V7.61h1.08ZM151.9 15.11h1.05v5.57a7.66 7.66 0 0 1-5.32 1.92c-4.48 0-7.78-3.21-7.78-7.55s3.3-7.55 7.8-7.55c2.15 0 4.04.68 5.36 2.04l-.68.73a6.27 6.27 0 0 0-4.65-1.77c-3.87 0-6.74 2.81-6.74 6.55 0 3.72 2.87 6.55 6.74 6.55 1.57 0 3.01-.38 4.22-1.36V15.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.52 7.61v14.88h-1.74l-8.93-11.1v11.1h-2.12V7.61h1.74l8.93 11.1V7.6h2.12Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.77 15.05c0-4.36 3.36-7.61 7.93-7.61 4.53 0 7.89 3.23 7.89 7.61 0 4.38-3.36 7.6-7.89 7.6-4.57.01-7.93-3.24-7.93-7.6Zm13.69 0c0-3.3-2.47-5.72-5.76-5.72a5.6 5.6 0 0 0-5.8 5.72 5.6 5.6 0 0 0 5.8 5.72c3.3 0 5.76-2.43 5.76-5.72Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.39 7.61-4.97 14.88h-2.23l-4.06-11.88-4.06 11.88h-2.28l-4.97-14.88H193l4.02 12.1 4.18-12.1h1.96l4.1 12.16 4.1-12.16h2.02Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09 7.61h1.06v14.88h-1.06V7.61Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.5,
    y1: 14.02,
    x2: 33.02,
    y2: 14.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 20.23,
    y1: 14.08,
    x2: 8.4,
    y2: 14.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 162.96,
    y1: -15.13,
    x2: 170.45,
    y2: 128.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 180.49,
    y1: -15.8,
    x2: 185.62,
    y2: 128.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 201.18,
    y1: -16.58,
    x2: 203.58,
    y2: 127.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.9086 0 0 19.9131 1.88 30.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h213.39v32H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdnLogoLight);
export default __webpack_public_path__ + "static/media/ddn_logo_light.e031f8853ee72847d82b5f51cdc0ef00.svg";
export { ForwardRef as ReactComponent };